export const defaultSettings = {
    reinvestSetting: {
        include: false,
        reinvestCapitalGains: true,
        reinvestDividends: true
    },
    subSequentSetting: {
        include: false,
        type: 12,
        frequency: 1,
        amount: 0.0,
        amountType: 0,
        liquidateOnEndDate: false
    },
    rebalanceSetting: {
        includeRebalance: false,
        rebalanceThreshold: 0,
        rebalancingTo: 0,
        rebalanceFrequency: 12
    },
    taxSetting: {
        includeTax: false,
        filingStatus: 1,
        taxableIncome: 100000,
        taxPayOption: 0,
        taxRate: {
            federalIncomeTaxRate: 0,
            capitalGainsTaxRate: 0,
            stateTaxRate: 0
        }
    },
    benchmarkSetting: {
        benchmarkType: 0,
        includeBenchmark: false,
        benchmarkHoldings: [
            {
                securityId: "XIUSA04G92",
                securityName: "S&P 500 TR USD",
                identifier: "XIUSA04G92"
            }
        ]
    },
    advisoryFeeSettings: {
        includeAdvisoryFee: false,
        annualFeeAmount: 0,
        annualFeeChargeFrequency: 1,
        annualFeePayMethod: 0,
        annualFeePayOnBegin: false
    },
    transactionFeeSettings: {
        includeTransactionFee: false,
        frontLoadType: 0,
        frontLoadAmountType: 0,
        loi: false,
        frontLoadAmount: null,
        redemptionCharge: true,
        chargeOnRebalancing: false,
        annualFeePayCashFirst: true
    }
};

// Apply default if section not included in preference or keys missing
const checkAndApplyDefault = (include, preferenceSetting, defaultSetting) => {
    if (!include) {
        return defaultSetting;
    }
    return { ...defaultSetting, ...preferenceSetting };
};

export const processAPIReinvestSetting = prefReinvestSetting => {
    return checkAndApplyDefault(prefReinvestSetting.include, prefReinvestSetting, defaultSettings.reinvestSetting);
};
export const processAPISubSequentSetting = prefSubSequentSetting => {
    return checkAndApplyDefault(prefSubSequentSetting.include, prefSubSequentSetting, defaultSettings.subSequentSetting);
};
export const processAPIRebalanceSetting = prefRebalanceSetting => {
    return checkAndApplyDefault(prefRebalanceSetting.includeRebalance, prefRebalanceSetting, defaultSettings.rebalanceSetting);
};
export const processAPITaxSetting = prefTaxSetting => {
    const taxSetting = checkAndApplyDefault(prefTaxSetting.includeTax, prefTaxSetting, defaultSettings.taxSetting);
    const { filingStatus, taxPayOption, taxRate, ...otherTaxSettings } = taxSetting;
    const { federalIncomeTaxRate, capitalGainsTaxRate, stateTaxRate } = taxRate;
    return {
        ...otherTaxSettings,
        taxPayType: taxPayOption,
        taxFilingStatus: filingStatus,
        federalTaxRate: federalIncomeTaxRate,
        capgainTaxRate: capitalGainsTaxRate,
        stateTaxRate
    };
};

export const processAPIFeeSetting = prefFeeSetting => {
    // Fee contains 2 includes, so need to be treated differenctly
    let result = prefFeeSetting;
    // If not include in preference, apply default values
    if (!prefFeeSetting.includeAdvisoryFee) {
        result = { ...result, ...defaultSettings.advisoryFeeSettings };
    }
    if (!prefFeeSetting.includeTransactionFee) {
        result = { ...result, ...defaultSettings.transactionFeeSettings };
    }
    return result;
};

export const processAPIBenchmarkSetting = prefBenchmarkSetting => {
    const { benchmarkType, includeBenchmark, benchmarkHoldings, customBenchmarkId, customBenchmarkName } = prefBenchmarkSetting;
    if (!includeBenchmark) {
        return defaultSettings.benchmarkSetting;
    }
    const benchmarkSetting = {
        benchmarkType,
        includeBenchmark
    };
    if (benchmarkType === 0) {
        benchmarkSetting.benchmarkHoldings = benchmarkHoldings;
    } else if (benchmarkType === 3) {
        benchmarkSetting.customBenchmarkId = customBenchmarkId;
        benchmarkSetting.customBenchmarkName = customBenchmarkName;
    }
    return benchmarkSetting;
};
